export default function GS_Relative_Reference() {
  return (
    <div className="p-4">
      <h1>GS Relative Reference</h1>
    </div>
  );
}
